module.exports = __webpack_public_path__ + "static/media/OK.e78717ca.png";